import React from 'react'

const Colombia = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <rect
            x="4.4"
            y="4.4"
            width="31.2"
            height="31.2"
            rx="15.6"
            stroke="#BCBCBC"
            strokeWidth="0.8"
        />
        <mask
            id="footer-flag-colombia"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="8"
            y="8"
            width="24"
            height="24"
        >
            <path
                d="M20 32C23.1826 32 26.2348 30.7357 28.4853 28.4853C30.7357 26.2348 32 23.1826 32 20C32 16.8174 30.7357 13.7652 28.4853 11.5147C26.2348 9.26428 23.1826 8 20 8C16.8174 8 13.7652 9.26428 11.5147 11.5147C9.26428 13.7652 8 16.8174 8 20C8 23.1826 9.26428 26.2348 11.5147 28.4853C13.7652 30.7357 16.8174 32 20 32Z"
                fill="#C4C4C4"
            />
        </mask>
        <g mask="url(#footer-flag-colombia)">
            <path d="M41.4671 7.46875H-1.59961V20.0288H41.4671V7.46875Z" fill="#F3D031" />
            <path d="M41.4671 20.0273H-1.59961V26.3207H41.4671V20.0273Z" fill="#313F88" />
            <path d="M41.4671 26.3203H-1.59961V32.6136H41.4671V26.3203Z" fill="#BC2433" />
        </g>
    </svg>
)

export default Colombia
